import { User } from "../../store/slices/User/reducer";

export type Question = {
  id: string;
  value: string;
  questionType: QuestionType;
  answerType: AnswerType;
  answerOptions: string[];
  response?: number | string | string[];
}

export enum QuestionType {
  TEXT = 'Text',
  BOOLEAN = 'Boolean',
  MULTIPLE = 'Multiple',
  RANGE_SCALE = 'RangeScale',
}

export enum AnswerType {
  SINGLE = 'Single',
  MULTIPLE = 'Multiple',
}

export enum SurveyStatus {
  PUBLISHED = 'PUBLISHED',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
}

export type SurveyConfig = {
  id: string
} & {
  [key: string]: boolean;
}

export type SurveyConfigDisplay = {
  value: string;
  label: string;
  response: string | number | string[];
  type: 'text' | 'number' | 'checkbox' | 'combo' | 'section';
  maxLength?: number;
  options?: string[];
};

export type SurveyRespondentInfo = {
  name: string,
  lastName: string,
  gender: string,
  email: string,
  age: string,
  phone: string,
  postalCode: string,
  curp: string,
  cic: string,
  section: string,
};

export type SurveyResponse = SurveyRespondentInfo & {
  id: number;
  validated: boolean;
  archived: boolean;
  createdAt: string;
  createdBy: User;
  updatedAt: string;
  answers: {
    [key: number]: string | number | string[];
  }
};

export type SurveyAnswer = {
  [key: string]: string | number | string[] | undefined;
};

export type Survey = {
  id: string;
  title: string;
  createdAt: string;
  updatedAt: string;
  creatdBy: string;
  updatedBy: string;
  status: SurveyStatus;
  responses: number;
  content: {
    questions: Question[];
  }
}

export type ElectoralSection = {
  id: string;
  label: string;
  sectionNumber: number;
  nominalList: number;
  nominalListMen: number;
  nominalListWomen: number;
  electoralRoll: number;
  electoralRollMen: number;
  electoralRollWomen: number;
}
